<template>
  <div>
    <v-img
      class="pa-0 ma-0"
      src="https://images.unsplash.com/photo-1599663253408-ddd8dadac635?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1349&q=80"
      gradient="#FFFFFF00, #000000"
      height="94vh"
    >
      <v-row class="mt-16">
        <v-col cols="12" align="center">
          <div class="topHalf">
            <listifyName class="mt-10" color="primary" :width="nameSize" />
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-n2">
        <v-col cols="12" align="center">
          <span class="primary--text text-md-h5 text-h6"
            >Stop Skipping! Listify!</span
          >
        </v-col>
      </v-row>
      <v-row class="mt-n2">
        <v-col cols="12" align="center">
          <span class="text-md-h5 text-h6"
            >Enhance your spotify playlist system</span
          >
        </v-col>
      </v-row>

      <div>
        <v-row class="pt-10">
          <v-col cols="12" align="center">
            <v-row class="pt-5">
              <v-col align="end">
                <v-btn
                  color="primary"
                  to="/profile"
                  @click="loading = !loading"
                  :loading="loading"
                  >Listify now!</v-btn
                >
              </v-col>
              <v-col align="start">
                <v-btn to="/documentation">What is Listify?</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-img>
    <!-- Removed until Impressum is available via fantasyflip -->
    <!-- <v-footer color="background">
      <v-row>
        <v-col align="center">Impressum</v-col>
      </v-row>
    </v-footer> -->
  </div>
</template>

<script>
import listifyName from "../components/general/listifyNameSvg.vue";
export default {
  name: "Home",
  title: "Home",

  components: {
    listifyName,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    redirectSpotifyAuth: function () {
      window.location = this.$authUrl;
    },
  },
  computed: {
    nameSize: function () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 330;
        case "sm":
          return 500;
        case "md":
          return 600;
        case "lg":
          return 650;
        case "xl":
          return 750;
        default:
          return 500;
      }
    },
  },
};
</script>

<style scoped>
.topHalf {
  height: 50vh;
  display: grid;
  place-items: center;
}
</style>